import { a as i, j as o } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { createContext as r, useEffect as l } from "react";
import { c as a, G as c } from "../../../emotion-react.browser.esm-C9Tl5GZI.js";
const m = r(null);
function g(n) {
  const {
    children: s
  } = n;
  return l(() => {
    const e = document.createElement("link");
    e.rel = "preconnect", e.href = "https://fonts.googleapis.com";
    const t = document.createElement("link");
    return t.rel = "preconnect", t.href = "https://fonts.gstatic.com", t.crossOrigin = "anonymous", document.head.appendChild(e), document.head.appendChild(t), () => {
      document.head.removeChild(e), document.head.removeChild(t);
    };
  }, []), /* @__PURE__ */ i(m.Provider, {
    value: null,
    children: [/* @__PURE__ */ o(d, {}), s]
  });
}
const d = () => (
  /**
   * 1) import Poppins font from Google Fonts
   *    - not using `@font-face` as we are importing fonts directly from Google Fonts URL
   * 2) override browser default font-weights for Poppins
   *    - our design system font includes the following font-weights: 400, 500 and 600. Therefore,
   *     the browser will attempt to workaround this when font keywords are used, such as
   *     `font-weight: bold`, which is typically represented as 700 and `heavy` as 900.
   *     We want to override these browser defaults to explicitly use our font weight values,
   *     such as `font-weight: bold` to be represented as 600 whenever this keyword style is used.
   */
  /* @__PURE__ */ o(c, {
    styles: a`
      @import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;1,400;1,600&display=swap");

      [style*="font-weight: normal"] {
        font-weight: var(--swing-font-normal) !important;
      }

      [style*="font-weight: bold"],
      [style*="font-weight: heavy"] {
        font-weight: var(--swing-font-semibold) !important;
      }
    `
  })
);
export {
  g as DesignSystemProvider
};
